import React, { useEffect } from 'react'
import BannerInnerOne from '../../components/child/BannerInnerOne'
import TopThreeChannel from '../../components/child/TopThreeChannel'
import ChartRevenue from '../../components/child/ChartRevenue'
import RecentActivity from '../../components/child/RecentActivity'
import TopFourLabel from '../../components/child/TopFourLabel'
import TopFourSong from '../../components/child/TopFourSong'
import RecentBidOne from '../../components/child/RecentBidOne'
import ETHPriceOne from '../../components/child/ETHPriceOne'
import RevenueEveryMonth from '../../components/child/RevenueEveryMonth'
import StatisticsOne from '../../components/child/StatisticsOne'
import StatisticsAdmin from '../../components/child/StatisticsAdmin'
import FeaturedCreatorsOne from '../../components/child/FeaturedCreatorsOne'
import FeaturedCreatorsTwo from '../../components/child/FeaturedCreatorsTwo'
import { useNavigate } from 'react-router-dom'
import PostByAgg from '../../utils/axios'
import { useAuth } from '../../context/AuthContext'

const Dashboard = () => {
    const {roleCode} = useAuth()
    const navigate = useNavigate();
    const { email } = useAuth();

  useEffect(() => {
  
    if (!email) {
      navigate('/login');
      return;
    }

    const url = 'user/um/v1/check-password-updated';
    PostByAgg({
      url: url,
      body: {
        'email': email
      },
      onResponse: onCheckPasswordResponse,
      onError: onCheckPasswordError,
    });

    function onCheckPasswordResponse(response) {
      console.log("dashboard",response.data)
      if (response.data.code === '2002000') {
        navigate('/dashboard')
      }
    }

    function onCheckPasswordError(error) {
      if (error.response.data.code === '4003400') {
        navigate('/change-password');
      }
    }
  }, [navigate]);

  const allowMonthlyRevenue = roleCode !== 'RL2505041947488';


//     return (
//         <>
//             <div className="row gy-4">
//                 <div className="col-xxl-8">
//                     <div className="row gy-4">

//                         {/* BannerInnerOne */}
//                         <BannerInnerOne />

//                         {/* TrendingBidsOne */}
//                         <TrendingBidsOne />


//                         {/* TrendingNFTsOne */}
//                         <TrendingNFTsOne />

//                         {/* RecentBidOne */}
//                         {/* <RecentBidOne /> */}

//                     </div>
//                 </div>

//                 <div className="col-xxl-4">
//                     <div className="row gy-4">

//                         {/* ETHPriceOne */}
//                         <ETHPriceOne />

//                         {/* StatisticsOne */}
//                         <StatisticsOne />

//                         {/* FeaturedCreatorsOne */}
//                         <FeaturedCreatorsOne />

//                         {/* FeaturedCreatorsTwo */}
//                         {/* <FeaturedCreatorsTwo /> */}

//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

//admin internal dan super admin internal
if (roleCode === 'RL2411062373407'|| roleCode === 'RL2411065833191') {
  return (
      <>
          <div className="row gy-4">
              <div className="col-xxl-8">
                  <div className="row gy-4">
                      <BannerInnerOne />
                      <TopThreeChannel />
                      <TopFourLabel />
                      <TopFourSong />
                  </div>
              </div>

              <div className="col-xxl-4">
                  <div className="row gy-4">
                      {/* ETHPriceOne */}
                      <RevenueEveryMonth />
                      {/* StatisticsOne*/}
                      <StatisticsAdmin />
                      {/* FeaturedCreatorsOne
                      <FeaturedCreatorsOne /> */}

                  </div>
              </div>
          </div>
      </>
  );
}

//admin label dan super admin label
if (roleCode === 'RL2411111120977' || roleCode === 'RL2411065833191' || roleCode === 'RL2505041947488') {
  return (
      <>
          <div className="row gy-4">
              <div className="col-xxl-8">
                  <div className="row gy-4">
                      {/* BannerInnerOne */}
                      <BannerInnerOne />

                      <TopThreeChannel />

                      {/* TrendingNFTsOne */}
                      <TopFourLabel />
                      
                     
                     {/* RecentBidOne
                      <RecentBidOne /> */}

                      {/* FeaturedCreatorsOne */}
                      <FeaturedCreatorsOne />

                  </div>
              </div>

              <div className="col-xxl-4">
                  <div className="row gy-4">

                      <ChartRevenue />
                      
                     {allowMonthlyRevenue &&  <RevenueEveryMonth />}
                  
                      {/* ETHPriceOne */}
                      {/* <ETHPriceOne /> */}

                      {/* StatisticsOne */}
                      <StatisticsOne />

                  </div>
              </div>
          </div>
      </>
  );
}

// Optional: fallback untuk roleCode yang tidak dikenali
return <div>Role user tidak dikenali.</div>;
};

export default Dashboard